import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private readonly showDelayMs = 180;
  private activeRequests = 0;
  private showTimer: ReturnType<typeof setTimeout> | null = null;

  readonly visible = signal(false);

  begin(): void {
    this.activeRequests++;

    if (this.activeRequests !== 1 || this.visible()) {
      return;
    }

    this.clearShowTimer();

    this.showTimer = setTimeout(() => {
      this.showTimer = null;

      if (this.activeRequests > 0) {
        this.visible.set(true);
      }
    }, this.showDelayMs);
  }

  end(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);

    if (this.activeRequests > 0) {
      return;
    }

    this.clearShowTimer();
    this.visible.set(false);
  }

  private clearShowTimer(): void {
    if (this.showTimer !== null) {
      clearTimeout(this.showTimer);
      this.showTimer = null;
    }
  }
}